import React from 'react';
import ErrorsProvider from './errors';
import GenericsProvider from './generics';
import InputsProvider from './inputs';
import LiferayProvider from './liferay';
import SearchProvider from './search';

export { ErrorsContext } from './errors';
export { GenericsContext } from './generics';
export { InputsContext } from './inputs';
export { LiferayContext } from './liferay';
export { SearchContext } from './search';

const ContextStore = ({ children }: { children: React.ReactNode }) => (
  <GenericsProvider>
    <LiferayProvider>
      <InputsProvider>
        <SearchProvider>
          <ErrorsProvider>{children}</ErrorsProvider>
        </SearchProvider>
      </InputsProvider>
    </LiferayProvider>
  </GenericsProvider>
);

export default ContextStore;
